import { PageNotFound, getNotFoundProps } from "@/lib/notFound"
import { GetStaticPropsContext } from "next"

export const getStaticProps = async (context: GetStaticPropsContext) => getNotFoundProps(context)
export default PageNotFound
